/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_FefoInputs */

const en_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack credits are consumed on a first-expiry-first-out (FEFO) basis: the oldest pack credits are used before subscription credits.`)
};

const de_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits aus Paketen werden nach dem FEFO-Prinzip verbraucht: Die aeltesten Paket-Credits werden zuerst aufgebraucht, bevor Abonnement-Credits belastet werden.`)
};

const fr_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les credits de packs sont consommes selon le principe FEFO (premier expire, premier utilise) : les credits les plus anciens sont utilises en premier.`)
};

const es_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los creditos de paquetes se consumen en orden FEFO (primero en expirar, primero en usarse): los creditos mas antiguos se usan primero.`)
};

const it_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I crediti dei pacchetti vengono consumati secondo il principio FEFO (primo a scadere, primo a essere usato): i crediti piu vecchi vengono usati per primi.`)
};

const nl_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack-credits worden verbruikt volgens het FEFO-principe (eerst verlopen, eerst verbruikt): de oudste pack-credits worden als eerste gebruikt.`)
};

const pl_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredyty z paczek sa zuzywane wedlug zasady FEFO (pierwszy wygasa, pierwszy zuzyty): najstarsze kredyty sa uzywane w pierwszej kolejnosci.`)
};

const fi_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakettien krediitit kulutetaan FEFO-periaatteella (vanhin ensin): vanhimmat pakettikrediitit käytetään ensin.`)
};

const da_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack-credits forbruges efter forst-udlober-forst-brugt-princippet (FEFO): de aeldste pack-credits bruges forst.`)
};

const sv_agb_credit_packs_fefo = /** @type {(inputs: Agb_Credit_Packs_FefoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketets krediter forbrukas enligt FEFO-principen (forst att lopa ut, forst att anvandas): de aldsta krediterna anvands forst.`)
};

/**
* | output |
* | --- |
* | "Pack credits are consumed on a first-expiry-first-out (FEFO) basis: the oldest pack credits are used before subscription credits." |
*
* @param {Agb_Credit_Packs_FefoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_fefo = /** @type {((inputs?: Agb_Credit_Packs_FefoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_FefoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_fefo(inputs)
	if (locale === "fr") return fr_agb_credit_packs_fefo(inputs)
	if (locale === "es") return es_agb_credit_packs_fefo(inputs)
	if (locale === "it") return it_agb_credit_packs_fefo(inputs)
	if (locale === "nl") return nl_agb_credit_packs_fefo(inputs)
	if (locale === "pl") return pl_agb_credit_packs_fefo(inputs)
	if (locale === "fi") return fi_agb_credit_packs_fefo(inputs)
	if (locale === "da") return da_agb_credit_packs_fefo(inputs)
	if (locale === "sv") return sv_agb_credit_packs_fefo(inputs)
	return en_agb_credit_packs_fefo(inputs)
});